module.exports = "/_next/static/images/architecture-b701e29ebfb3fdf727b52eb7df686269.png.webp";